﻿import {LinkNode, AutoLinkNode} from "@lexical/link";
import {QuoteNode} from "@lexical/rich-text";
import {ListNode, ListItemNode} from "@lexical/list";
import { YouTubeNode } from "./nodes/youtube-node";
import { ImageNode } from "./nodes/image-node";
import { VideoNode } from "./nodes/video-node";

import {CreateEditorArgs} from 'lexical';

const exampleTheme = {
    text: {
        underline: 'text-decoration-underline',
    }
};

const lexicalEditorConfig: CreateEditorArgs = {
    namespace: 'MyEditor',
    editable: true,
    theme: exampleTheme,
    onError: console.log,
    nodes: [QuoteNode, ListNode, ListItemNode, LinkNode, AutoLinkNode, YouTubeNode, ImageNode, VideoNode]
};

export default lexicalEditorConfig;
